import {Nature, NatureCycle} from "src/_generated/typed-document-nodes"
import {DocumentType} from "src/utils/@types/DocumentType"
import CommonUtils from "src/utils/Common"

// based on NatureCycle enum generated by graphql
const NATURE_CYCLE = Object.fromEntries(Object.values(NatureCycle).map((v) => [v, v]))

const NATURE_CODE_STARTS_BY = Object.fromEntries(
    Object.values(NatureCycle).map((v) => {
        const valEscaped = v.replaceAll("_", "")
        return [valEscaped, valEscaped]
    })
)

// create union type from the values of the object
export type NatureCycleUnion = (typeof NATURE_CYCLE)[keyof typeof NATURE_CYCLE]

const DOCUMENTS_TO_NOT_REQUEST = ["O2CMisc", "P2PMisc"]
const CHORUS_NATURES = ["ChorusB2G"]

const isO2C = (cycle: string) => cycle === NATURE_CYCLE.O_2_C
const isP2P = (cycle: string) => cycle === NATURE_CYCLE.P_2_P
const isOldReform = (cycle: string) => cycle === "O2CInv" || cycle === "P2PInv"

const getNatureCycleByDocumentType = (documentType: string) => {
    const existingDocumentType: DocumentType = CommonUtils.GetAllDocTypes().find(
        (item: DocumentType) => item.code === documentType
    )

    const nature: Nature = CommonUtils.GetAllNatures().find(
        (item: Nature) => item.code?.toUpperCase() === existingDocumentType.natureCode?.toUpperCase()
    )

    return nature.cycle
}

const MISC = "MISC"
const O2C = "O2C"
const P2P = "P2P"

export {
    CHORUS_NATURES,
    DOCUMENTS_TO_NOT_REQUEST,
    getNatureCycleByDocumentType,
    isO2C,
    isOldReform,
    isP2P,
    MISC,
    NATURE_CODE_STARTS_BY,
    NATURE_CYCLE,
    O2C,
    P2P
}
